import React from 'react';
import { IconArrowRightBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';
import { formatKoreanNumber } from '@domains/pdp-common';

interface BenefitCardProps {
  cardName: string;
  discount_amount: number;
  onClick?: () => void;
}

export const PaymentBenefitCard: React.FC<React.PropsWithChildren<BenefitCardProps>> = ({ cardName, discount_amount, onClick }) => {
  return (
    <Card className={Typography.BODY_14_REGULAR} key={cardName + discount_amount} onClick={() => onClick?.()}>
      <Div>
        {cardName} <span>최대 {formatKoreanNumber(discount_amount)}</span> 할인
        <IconArrowRightBold className='icon' size={18} v3Color='gray500' />
      </Div>
    </Card>
  );
};

const Card = styled.div`
  position: relative;
  top: -2px;
  display: flex;
  align-items: center;
  padding: 2px 18px 4px 0;
  border: none;
  word-break: keep-all;
  color: ${vars.color.textStrong};
  line-height: 18px;

  span {
    font-weight: 500;
  }

  .icon {
    position: absolute;
    right: -18px;
    top: 0;
  }
`;

const Div = styled.div`
  position: relative;
`;
